export enum BasicAction {
  add = 'add',
  update = 'update',
  updateMy = 'update-my',
  updateList = 'update-list',
  delete = 'delete',
  deleteMy = 'delete-my',
  modifyAllItems = 'modify-all-items',
  getItem = 'get-item',
  getMy = 'get-my',
}
